import React, { useState, useEffect } from 'react'
import i18n from '../../i18n'
import { withTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { 
    Box,
    Typography
} from '@material-ui/core';

import govLogo from '../../images/govHK_logo.png'
// import transportIco from '../../images/transport.svg'

import './Header.scss'
import { Link, useParams } from 'react-router-dom';

export default withTranslation()(function Header({ t, i18n, langLock }) {
    const pathPrefix = process.env.REACT_APP_SUB_ROUTE;
    return (
        <Box className="header">
            <Box className="headerTop">
                <Box className="logo">
                    <img src={govLogo} alt="" />
                </Box>
                <Box className="rightTool">
                    {!langLock &&
                    <Box>
                        {i18n.language !== "tc"?
                        <a href={`${pathPrefix}/tc`}>
                            {t('common.langSwitch_tc')}
                        </a>
                        :<a href={`${pathPrefix}/en`}>
                        {t('common.langSwitch_en')}
                    </a>}
                    </Box>
                    }
                </Box>
            </Box>
            <Box className="headerTitle">
                <Box className="deco"></Box>
                {/* <img src={transportIco} alt="" /> */}
                <Typography variant="h5" component="h1">
                    {t('common.formName')}
                </Typography>
            </Box>

            {/* <Box>
                <button onClick={() => changeLanguage('tc')}>tc</button>
                <button onClick={() => changeLanguage('en')}>en</button>
            </Box> */}
        </Box>
    )
})
